
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.208","height":"5.928"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Back","d":"M15.371 14.583l-.916.921a.75.75 0 101.063 1.058l2.208-2.219a.75.75 0 000-1.061L15.5 11.074a.75.75 0 00-1.058 1.063l.951.946h-4.91a.75.75 0 000 1.5z","transform":"rotate(180 8.973 8.392)","fill":"#5a677d"}})])
          )
        }
      }
    